import { render, staticRenderFns } from "./PaginaModa.vue?vue&type=template&id=dc3109ea"
import script from "./PaginaModa.vue?vue&type=script&lang=js"
export * from "./PaginaModa.vue?vue&type=script&lang=js"
import style0 from "./PaginaModa.vue?vue&type=style&index=0&id=dc3109ea&prod&lang=css"
import style1 from "@/assets/fusion.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports